import { IAccount } from "../../models/account/IAccount";
import { CheckboxInput } from "../shared/Inputs/CheckboxInput";
import { TextInput } from "../shared/Inputs/TextInput";
import { AccountPrimaryContactSection } from "./AccountPrimaryContactSection";
import { IContact } from "../../models/Contact";

interface AccountEditDetailsSectionProps {
  account?: IAccount;
  register: any;
  setValue: any;
  watch: any;
  primaryContactOptions: { id: string; name: string }[];
  primaryContact?: IContact;
  setPrimaryContact: (contact: IContact) => void;
  isPrimaryContactOpen: boolean;
  setIsPrimaryContactOpen: (open: boolean) => void;
  onAddContact: () => void;
  onEditContact: () => void;
}

export function AccountEditDetailsSection({
  account,
  register,
  setValue,
  watch,
  primaryContactOptions,
  primaryContact,
  setPrimaryContact,
  isPrimaryContactOpen,
  setIsPrimaryContactOpen,
  onAddContact,
  onEditContact,
}: AccountEditDetailsSectionProps) {
  return (
    <div className="space-y-3 rounded-md border border-gray-200 bg-white p-4">
      <div className="pb-1 border-b border-gray-100">
        <p className="text-sm font-semibold text-gray-800">Account</p>
        <p className="text-xs text-gray-500">Core details and ownership</p>
      </div>
      <TextInput
        label="Account Number"
        register={register}
        registerName="accountNumber"
        disabled={true}
        rounded
      />
      <TextInput
        label="Account Name"
        register={register}
        registerName="name"
        rounded
      />
      <CheckboxInput
        label="Regulars Account"
        register={register}
        registerName="regularsAccount"
        rounded
      />
      <AccountPrimaryContactSection
        account={account}
        register={register}
        setValue={setValue}
        watch={watch}
        primaryContactOptions={primaryContactOptions}
        primaryContact={primaryContact}
        setPrimaryContact={setPrimaryContact}
        isOpen={isPrimaryContactOpen}
        setIsOpen={setIsPrimaryContactOpen}
        onAddContact={onAddContact}
        onEditContact={onEditContact}
      />
    </div>
  );
}

